// Module
var code = `<table class="branches-list table" at-table at-list="\$ctrl.branches">
  <thead></thead>
  <tbody class="tbody">
  <tr>
    <td class="branches-list__number-column" at-title="No">
      {{\$index+1+'.'}}
    </td>
    <td at-implicit at-attribute="organization.name" at-title="Organization"></td>
    <td at-implicit at-attribute="name" at-title="Branch name"></td>
    <td at-implicit at-attribute="location" at-title="Branch location"></td>
    <td class="branches-list__open-link-column">
      <a class="btn btn-primary open-link" ng-href="{{\$ctrl.detailLink}}/{{item.id}}">Open</a>
    </td>
  </tr>
  </tbody>
</table>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/branches-list/branches-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;